import Col from "react-bootstrap/esm/Col";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import { Alert } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { useAtom } from "@dbeining/react-atom";
import { userAtom } from "../../atoms";
import { HubCardGrid } from "../HubCards/HubCardGrid";
import { HUB_WELCOME_DESCRIPTION, type HubCardDef } from "../../navigation/appNavigation";
import {
    filterNavItemsByRoles,
    getUserRoleNames,
    HUB_EMPTY_MESSAGE,
} from "../../navigation/navVisibility";

type Props = {
    title: string;
    helmetTitle?: string;
    description?: string;
    cards: HubCardDef[];
};

const SectionHubPage = ({ title, helmetTitle, description = HUB_WELCOME_DESCRIPTION, cards }: Props) => {
    const currentUser = useAtom(userAtom);
    const userRoleNames = getUserRoleNames(currentUser?.identity.roles ?? []);
    const visibleCards = filterNavItemsByRoles(cards, userRoleNames);

    return (
        <Container fluid>
            <Row>
                <Col>
                    <Helmet>
                        <title>{helmetTitle ?? title}</title>
                    </Helmet>
                    <h1 className="my-3">{title}</h1>
                    <p className="text-muted">{description}</p>
                    {visibleCards.length === 0 ? (
                        <Alert variant="info" className="mt-3">
                            {HUB_EMPTY_MESSAGE}
                        </Alert>
                    ) : (
                        <HubCardGrid cards={visibleCards} />
                    )}
                </Col>
            </Row>
        </Container>
    );
};

export { SectionHubPage };
